import type { LinhaGantt } from '../../api/projetos.js';
import { diasEntre } from './timeline-utils.js';

interface SetasDependenciaProps {
  linhas: LinhaGantt[];
  linhaTopoPorId: Map<string, number>;
  dataInicioEixo: string;
  diaPx: number;
  alturaLinha: number;
}

// SPEC-UX §10.1 — setas conectando fim da predecessora ao início da
// sucessora; âmbar quando marca conflito, grafite caso contrário.
export function SetasDependencia({ linhas, linhaTopoPorId, dataInicioEixo, diaPx, alturaLinha }: SetasDependenciaProps) {
  const porId = new Map(linhas.map((l) => [l.atividadeId, l]));

  return (
    <svg className="pointer-events-none absolute inset-0 overflow-visible">
      <defs>
        <marker id="seta-dependencia" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
          <path d="M0,0 L7,3.5 L0,7 Z" className="fill-grafite" />
        </marker>
        <marker id="seta-dependencia-conflito" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
          <path d="M0,0 L7,3.5 L0,7 Z" className="fill-status-ambar" />
        </marker>
      </defs>
      {linhas.map((linha) => {
        if (!linha.predecessoraId) return null;
        const predecessora = porId.get(linha.predecessoraId);
        if (!predecessora || !predecessora.fimPrevisto || !linha.inicioPrevisto) return null;

        const yDe = linhaTopoPorId.get(predecessora.atividadeId);
        const yPara = linhaTopoPorId.get(linha.atividadeId);
        if (yDe === undefined || yPara === undefined) return null;

        const xFim = diasEntre(dataInicioEixo, predecessora.fimPrevisto) * diaPx;
        const xInicio = diasEntre(dataInicioEixo, linha.inicioPrevisto) * diaPx;
        const yFim = yDe + alturaLinha / 2;
        const yInicio = yPara + alturaLinha / 2;
        const meioX = xFim + 10;

        return (
          <path
            key={linha.atividadeId}
            d={`M${xFim},${yFim} L${meioX},${yFim} L${meioX},${yInicio} L${xInicio - 2},${yInicio}`}
            className={linha.conflito ? 'stroke-status-ambar' : 'stroke-grafite'}
            strokeWidth={1.5}
            fill="none"
            markerEnd={linha.conflito ? 'url(#seta-dependencia-conflito)' : 'url(#seta-dependencia)'}
          />
        );
      })}
    </svg>
  );
}
